import { useMemo } from 'react';
import { useTranslate } from 'ra-core';
import { type CsvRecord, type GridRow } from './types';
import { type RenderCellProps } from 'react-data-grid';
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '../../components/ui/tooltip';

export function BulkOperationDialogGridCell<T extends CsvRecord>({
  column: { key },
  row,
}: RenderCellProps<GridRow<T>>) {
  const translate = useTranslate();
  const columnKey = key as keyof T;

  const value = useMemo(() => {
    const val = row.data[columnKey];

    // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
    return val === null || val === undefined ? '' : `${val}`;
  }, [row, columnKey]);

  const errorMessage = useMemo(
    () =>
      [...row.csvErrors, ...row.asyncErrors]
        .filter((error) => error.property === columnKey)
        .map((error) => error.message)
        .join(', '),
    [row, columnKey]
  );

  // The grid provides the TooltipProvider
  return errorMessage ? (
    <Tooltip>
      <TooltipTrigger
        render={
          <div className="rdg-cell-error">
            {value ||
              translate('moonstar.bulk_operation.required', {
                _: 'REQUIRED',
              })}
          </div>
        }
      />
      <TooltipContent>{errorMessage}</TooltipContent>
    </Tooltip>
  ) : (
    <div>{value}</div>
  );
}
